// extracted by mini-css-extract-plugin
export default {"highlightTm":"BDiseaseItem-module_highlightTm_dbd95407"};